import { signatureStyle as style } from 'now-frontend-shared/styles/signature-styles';

export const signatureStyle = {
  ...style,
};
